import MqUtils from "../common/utils/mq.es6";
import AnimeUtils from "../common/utils/anime.es6";

export default class MainMv {
    constructor(main) {
        this.main = main;
    }

    setAnimate() {
        this.setAnimationEnd();
    }

    setAnimationEnd() {
        const mvTxtItem = document.querySelector(".js-sub-mv-txt");
        //console.log(mvTxtItem);
        if (mvTxtItem) {
            mvTxtItem.addEventListener("animationend", () => {
                setTimeout(() => {
                    document.body.classList.add("-animationEnd");
                }, 500);
            });
        }

        this.main.scroll.setScrollReveal();

        // メインKV・バナーの自動再生を開始（存在する時だけ）
        const { swipers } = this.main.slider || {};
        swipers?.mainKv?.autoplay?.start?.();
        swipers?.bnr?.autoplay?.start?.();
    }
}
